var _path, _rect, _rect2, _path2, _path3, _path4, _rect3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _ellipse2, _path33, _path34, _path35, _path36, _ellipse3, _path37, _path38, _path39;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNoFeedback = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 200,
    viewBox: "0 0 273 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5895 16.7813C-33.094 64.1757 21.0303 129.698 55.8028 156.534C104.59 194.187 217.411 230.226 264.318 156.534C316.414 74.6894 105.694 -42.4618 28.5895 16.7813Z",
    fill: "#F4F5F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.4316,
    y: 37.1533,
    width: 116.879,
    height: 117.041,
    rx: 4.20363,
    fill: "#D0D2D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.6816,
    y: 45.4141,
    width: 100.378,
    height: 100.517,
    rx: 4.20363,
    fill: "#90959B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.622 49.6177C149.622 47.2961 151.504 45.4141 153.826 45.4141H170.857C173.178 45.4141 175.06 47.2961 175.06 49.6177V140.932C175.06 144.337 171.223 146.329 168.438 144.369L151.407 132.385C150.288 131.598 149.622 130.315 149.622 128.947V49.6177Z",
    fill: "#82878D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9478 145.931C78.6262 145.931 76.7441 144.049 76.7441 141.727L76.7441 133.611C76.7441 131.289 78.6262 129.407 80.9478 129.407L149.53 129.407C150.116 129.407 150.695 129.53 151.23 129.766L169.582 137.883C173.738 139.721 172.426 145.931 167.881 145.931L80.9478 145.931Z",
    fill: "#767B81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6816 46.211L121.849 25.1083C122.948 24.6167 124.192 25.4052 124.217 26.6087L126.796 152.336C126.865 155.684 123.712 158.169 120.473 157.319L74.6816 145.308V46.211Z",
    fill: "#A9ADB1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 122.121,
    y: 24.7607,
    width: 4.81266,
    height: 132.876,
    rx: 0.840727,
    fill: "#D0D2D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.412 91.1987C109.412 95.8735 108.148 100.06 106.159 103.047C104.166 106.042 101.524 107.734 98.7445 107.734C95.9652 107.734 93.3234 106.042 91.3297 103.047C89.3409 100.06 88.0775 95.8735 88.0775 91.1987C88.0775 86.5239 89.3409 82.3378 91.3297 79.3504C93.3234 76.3557 95.9652 74.6635 98.7445 74.6635C101.524 74.6635 104.166 76.3557 106.159 79.3504C108.148 82.3378 109.412 86.5239 109.412 91.1987Z",
    stroke: "#3F4348",
    strokeWidth: 2.04176
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.918 87.8511L108.344 81.999",
    stroke: "#3F4348",
    strokeWidth: 1.02088
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.423 84.926L107.51 82.8359",
    stroke: "#3F4348",
    strokeWidth: 2.04176,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3955 99.9728L92.4826 97.8828",
    stroke: "#3F4348",
    strokeWidth: 2.04176,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3955 100.389L95.822 94.5371",
    stroke: "#3F4348",
    strokeWidth: 1.02088
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.876 94.7539L107.72 100.188",
    stroke: "#3F4348",
    strokeWidth: 1.02088
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.798 97.2627L106.885 99.3527",
    stroke: "#3F4348",
    strokeWidth: 2.04176,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7703 82.2158L91.8574 84.3058",
    stroke: "#3F4348",
    strokeWidth: 2.04176,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3533 82.2158L95.1973 87.6499",
    stroke: "#3F4348",
    strokeWidth: 1.02088
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.7444,
    cy: 90.3619,
    rx: 5.00909,
    ry: 7.52405,
    fill: "#82878D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.266 85.4379L98.4558 84.2971C98.9651 84.115 99.5257 84.362 99.7111 84.8701C100.142 86.0523 100.821 88.1733 100.821 89.8139C100.821 91.4813 100.12 93.6449 99.6901 94.8149C99.5123 95.2987 98.9907 95.5486 98.495 95.4068L95.5179 94.555C93.7655 94.0537 92.5576 92.4517 92.5576 90.629V89.2829C92.5576 87.5578 93.6417 86.0188 95.266 85.4379Z",
    fill: "#3F4348"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.418 95.1684C98.5846 93.2213 97.9041 87.0555 97.418 84.4594L99.3624 83.9727C101.364 85.5761 101.764 91.9901 100.163 95.9988L97.418 95.1684Z",
    fill: "#4F545A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4189 84.9458L99.8494 84.459",
    stroke: "#A9ADB1",
    strokeWidth: 0.357309,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7617 85.9795H100.564",
    stroke: "#A9ADB1",
    strokeWidth: 0.357309,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9053 87.3818H100.564",
    stroke: "#A9ADB1",
    strokeWidth: 0.357309,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9053 88.8428H100.822",
    stroke: "#A9ADB1",
    strokeWidth: 0.357309,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9053 90.79H100.965",
    stroke: "#A9ADB1",
    strokeWidth: 0.357309,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7617 92.3916L100.564 92.7919",
    stroke: "#A9ADB1",
    strokeWidth: 0.357309,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9053 94.1963L100.336 94.6831",
    stroke: "#A9ADB1",
    strokeWidth: 0.357309,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M160.44 45.4131C160.801 48.0626 158.748 54.7366 148.935 58.4941",
    stroke: "white",
    strokeWidth: 0.533333,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M157.914 52.2793C158.876 52.6406 161.233 53.7245 162.965 55.1697C165.13 56.9762 165.852 55.531 166.212 58.4214C166.573 61.3117 166.934 63.4795 166.212 65.286C165.491 67.0925 166.212 69.8201 166.212 70.5427",
    stroke: "white",
    strokeWidth: 0.533333,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M166.212 58.0564C168.737 57.0929 174.005 55.2383 174.871 55.5273",
    stroke: "white",
    strokeWidth: 0.533333,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.616 45.7734C149.375 46.496 148.966 48.158 149.255 49.0251C149.616 50.109 148.894 57.6963 148.533 58.0576",
    stroke: "white",
    strokeWidth: 0.533333,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M135.184 45.7734C135.544 48.0617 136.266 52.8549 136.266 53.722C136.266 54.8059 138.792 62.7544 140.956 62.7544C143.121 62.7544 143.843 60.9479 144.925 60.5866C146.008 60.2253 147.559 58.5282 147.559 57.8056",
    stroke: "white",
    strokeWidth: 0.533333,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M136.626 45.7734C137.468 47.5799 139.512 51.4819 140.956 52.6381C142.76 54.0833 146.728 57.335 148.172 58.0576C149.615 58.7802 152.862 62.0318 155.027 64.1996C157.191 66.3674 173.427 74.3159 174.871 73.5934",
    stroke: "white",
    strokeWidth: 0.533333,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M199.638 124.866L197.297 129.554C197.123 129.903 197.211 130.326 197.511 130.576L198.057 131.032C198.398 131.316 198.9 131.286 199.206 130.965L203.557 126.377C203.783 126.139 203.85 125.792 203.728 125.487L203.146 124.03C202.968 123.585 202.454 123.378 202.017 123.577L200.042 124.476C199.867 124.556 199.724 124.693 199.638 124.866Z",
    fill: "#FCDF98"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M191.721 129.871L196.942 130.226C197.331 130.253 197.651 130.544 197.715 130.929L197.83 131.633C197.902 132.07 197.623 132.488 197.192 132.588L191.037 134.021C190.717 134.095 190.383 133.976 190.182 133.716L189.223 132.476C188.93 132.097 189.012 131.549 189.404 131.273L191.181 130.023C191.338 129.912 191.529 129.858 191.721 129.871Z",
    fill: "#FCDF98"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M202.777 132.461L199.021 131.517C198.642 131.422 198.379 131.079 198.385 130.688L198.388 130.452C198.395 130.008 198.744 129.646 199.186 129.624L203.82 129.391C204.148 129.374 204.455 129.551 204.607 129.842L205.028 130.651C205.25 131.076 205.072 131.601 204.637 131.803L203.335 132.408C203.16 132.489 202.963 132.508 202.777 132.461Z",
    fill: "#FCDF98"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M196.669 136.431L197.76 132.709C197.87 132.335 197.708 131.934 197.369 131.742L197.164 131.625C196.779 131.406 196.289 131.524 196.046 131.895L193.497 135.776C193.317 136.051 193.313 136.405 193.486 136.683L193.969 137.457C194.223 137.864 194.766 137.976 195.161 137.703L196.341 136.886C196.499 136.776 196.615 136.616 196.669 136.431Z",
    fill: "#FCDF98"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.14006,
    cy: 4.6139,
    rx: 1.14006,
    ry: 4.6139,
    transform: "matrix(0.823496 -0.567321 0.566256 0.824229 194.784 128.946)",
    fill: "#FCDF98"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M148.663 80.943L144.462 81.6572C144.077 81.7226 143.788 82.0443 143.764 82.4341L143.74 82.806C143.712 83.2484 144.032 83.6364 144.471 83.6929L149.548 84.3469C149.874 84.3889 150.195 84.237 150.369 83.9581L150.95 83.026C151.204 82.619 151.067 82.0823 150.65 81.8472L149.215 81.0391C149.047 80.9447 148.852 80.9108 148.663 80.943Z",
    fill: "#FCDF98"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.39 78.0739L143.668 81.6801C143.877 82.0099 143.831 82.44 143.558 82.7187L143.298 82.9846C142.988 83.3013 142.485 83.3226 142.15 83.0333L138.27 79.6897C138.021 79.4753 137.92 79.1355 138.01 78.8197L138.314 77.7632C138.446 77.302 138.937 77.045 139.391 77.1988L140.949 77.7268C141.132 77.7885 141.287 77.9111 141.39 78.0739Z",
    fill: "#FCDF98"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M145.093 86.8122L143.916 83.9112C143.772 83.5567 143.89 83.1497 144.202 82.9283C144.556 82.6768 145.044 82.7436 145.318 83.081L147.662 85.972C147.869 86.2271 147.909 86.5796 147.764 86.8744L147.523 87.3639C147.311 87.7943 146.783 87.9602 146.363 87.7283L145.465 87.2321C145.297 87.1389 145.165 86.9907 145.093 86.8122Z",
    fill: "#FCDF98"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M139.418 84.6518L142.359 83.5891C142.718 83.4591 142.942 83.0984 142.898 82.7182C142.848 82.2865 142.472 81.9678 142.039 81.9896L138.324 82.1766C137.996 82.1931 137.708 82.3994 137.586 82.7048L137.384 83.2114C137.206 83.657 137.435 84.1609 137.888 84.3183L138.857 84.6553C139.039 84.7185 139.237 84.7173 139.418 84.6518Z",
    fill: "#FCDF98"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.961434,
    cy: 3.88848,
    rx: 0.961434,
    ry: 3.88848,
    transform: "matrix(0.943239 0.330255 -0.329848 0.944687 143.519 79.6602)",
    fill: "#FCDF98"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M137.935 109.099V94.2969",
    stroke: "#15222F",
    strokeWidth: 0.840727,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M149.622 116.328L160.622 111.509",
    stroke: "#15222F",
    strokeWidth: 0.840727,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M144.358 111.974L147.56 105.653",
    stroke: "#15222F",
    strokeWidth: 0.840727,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoFeedback, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-feedback.870ae400.svg";
export { ForwardRef as ReactComponent };